export default __webpack_public_path__ + "../staticImages/cs_logo.png";